import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const CompactIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path
        d="M14.2299 17.994C14.2194 17.244 13.7041 14.761 14.2307 14.234C14.7572 13.708 17.2399 14.224 17.9896 14.235M20.9997 20.998L14.6149 14.614"
        stroke="currentColor"
      />

      <path
        d="M6.00863 9.76096C6.75836 9.77096 9.2419 10.283 9.76761 9.75595C10.2932 9.22795 9.77382 6.74597 9.76214 5.99597M9.37813 9.36697L3.00293 3.00195"
        stroke="currentColor"
      />
    </SvgIcon>
  )
}
